<div *appHasAnyAuthority="['ADMIN', 'UPDATE', 'INTL', 'DFS', 'CRADLEPOINT_PRO']">
    <h1>Fortinet</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN', 'INTL']" [routerLink]="['fortigate-provisioning']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>offline_bolt</mat-icon>
                    Fortigate Provisioning
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Provision Fortigate routers</p>
            </mat-card-content>
        </mat-card>
    </div>
    <h1>Meraki</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="['meraki-go-provisioning']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>cloud</mat-icon>
                    Meraki Provisioning
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Onboard new Meraki networks and managed switches</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="['network-tags']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>turned_in</mat-icon>
                    Network Tags
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Update network tags</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="['meraki-admin-audit']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>account_box</mat-icon>
                    Meraki Admin Audit
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>See all admins and their permissions in Meraki Dashboard</p>
            </mat-card-content>
        </mat-card>
    </div>
    <h1>Mist</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="['mist-rogue-ap-audit']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>account_box</mat-icon>
                    Mist Rogue AP Audit
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Detect if other access points are emitting the same SSID as Mist APs</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN']" [routerLink]="['mist-guest-wifi']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>wifi</mat-icon>
                    Mist Guest Wifi
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Control the Guest WiFi for Mist sites</p>
            </mat-card-content>
        </mat-card>
    </div>
    <h1>Network Audit</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="['site-audit']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>receipt</mat-icon>
                    Site Audit
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View restaurant network misconfigurations</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN']" [routerLink]="['chain-audit']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>receipt</mat-icon>
                    Chain Wide Audit
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View chain wide network</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN', 'INTL', 'DFS']" [routerLink]="['kevlar2-validation']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>settings_input_component</mat-icon>
                    Kevlar2 Validation
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Validate a store's Kevlar2 installation</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN']" [routerLink]="['kevlar2-config']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>receipt</mat-icon>
                    Kevlar2 Config
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View necessary data for a config request to Comcast</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['UPDATE', 'ADMIN', 'INTL']" [routerLink]="['site-ip-info']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>receipt</mat-icon>
                    Site IP Info
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View the LAN and WAN1 IPs that are used for router provisioning</p>
            </mat-card-content>
        </mat-card>
    </div>
    <h1>Cradlepoint</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['ADMIN', 'CRADLEPOINT_PRO', 'UPDATE', 'INTL']" [routerLink]="['cradlepoint-provisioning']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>account_box</mat-icon>
                    Cradlepoint Provisioning
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Onboard new cradlepoint routers</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>